// extracted by mini-css-extract-plugin
module.exports = {"offer":"offer_offer__3eozV","offerTitle":"offer_offerTitle__1VIl7","offerText":"offer_offerText__218CL","offerButton":"offer_offerButton__1t2wh"};